// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import { createContext, useContext } from 'react';

export interface AuthSyncState {
  /** The Clerk session could not be exchanged for an app token. */
  failed: boolean;
  /** Why it failed, for the user to read. */
  error: string | null;
  /** Try the exchange again. */
  retry: () => void;
}

export const AuthSyncContext = createContext<AuthSyncState>({
  failed: false,
  error: null,
  retry: () => {},
});

export const useAuthSync = (): AuthSyncState => useContext(AuthSyncContext);
